import {CountryResponseBody} from '@dms/api/shared';

export const countriesResponseMock: CountryResponseBody[] = [
  {
    code: 'ABW',
    name: 'Aruba',
    preferred: false,
    primaryCurrency: 'AWG',
  },
  {
    code: 'AFG',
    name: 'Afghanistan',
    preferred: false,
    primaryCurrency: 'AFN',
  },
  {
    code: 'AGO',
    name: 'Angola',
    preferred: false,
    primaryCurrency: 'AOA',
  },
  {
    code: 'AIA',
    name: 'Anguilla',
    preferred: false,
    primaryCurrency: 'XCD',
  },
  {
    code: 'ALA',
    name: 'Åland Islands',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'ALB',
    name: 'Albania',
    preferred: false,
    primaryCurrency: 'ALL',
  },
  {
    code: 'AND',
    name: 'Andorra',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'ARE',
    name: 'United Arab Emirates',
    preferred: false,
    primaryCurrency: 'AED',
  },
  {
    code: 'ARG',
    name: 'Argentina',
    preferred: false,
    primaryCurrency: 'ARS',
  },
  {
    code: 'ARM',
    name: 'Armenia',
    preferred: false,
    primaryCurrency: 'AMD',
  },
  {
    code: 'ASM',
    name: 'American Samoa',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'ATA',
    name: 'Antarctica',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'ATF',
    name: 'French Southern Territories',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'ATG',
    name: 'Antigua and Barbuda',
    preferred: false,
    primaryCurrency: 'XCD',
  },
  {
    code: 'AUS',
    name: 'Australia',
    preferred: false,
    primaryCurrency: 'AUD',
  },
  {
    code: 'AUT',
    name: 'Austria',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'AZE',
    name: 'Azerbaijan',
    preferred: false,
    primaryCurrency: 'AZN',
  },
  {
    code: 'BDI',
    name: 'Burundi',
    preferred: false,
    primaryCurrency: 'BIF',
  },
  {
    code: 'BEL',
    name: 'Belgium',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'BEN',
    name: 'Benin',
    preferred: false,
    primaryCurrency: 'XOF',
  },
  {
    code: 'BES',
    name: 'Bonaire, Sint Eustatius and Saba',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BFA',
    name: 'Burkina Faso',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BGD',
    name: 'Bangladesh',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BGR',
    name: 'Bulgaria',
    preferred: false,
    primaryCurrency: 'BGN',
  },
  {
    code: 'BHR',
    name: 'Bahrain',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BHS',
    name: 'Bahamas',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BIH',
    name: 'Bosnia and Herzegovina',
    preferred: false,
    primaryCurrency: 'BAM',
  },
  {
    code: 'BLM',
    name: 'Saint Barthélemy',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'BLR',
    name: 'Belarus',
    preferred: false,
    primaryCurrency: 'BYN',
  },
  {
    code: 'BLZ',
    name: 'Belize',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BMU',
    name: 'Bermuda',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BOL',
    name: 'Bolivia (Plurinational State of)',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BRA',
    name: 'Brazil',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BRB',
    name: 'Barbados',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BRN',
    name: 'Brunei Darussalam',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BTN',
    name: 'Bhutan',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BVT',
    name: 'Bouvet Island',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'BWA',
    name: 'Botswana',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CAF',
    name: 'Central African Republic',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CAN',
    name: 'Canada',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CCK',
    name: 'Cocos (Keeling) Islands',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CHE',
    name: 'Switzerland',
    preferred: false,
    primaryCurrency: 'CHF',
  },
  {
    code: 'CHL',
    name: 'Chile',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CHN',
    name: 'China',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CIV',
    name: "Côte d'Ivoire",
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CMR',
    name: 'Cameroon',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'COD',
    name: 'Congo (Democratic Republic of the)',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'COG',
    name: 'Congo',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'COK',
    name: 'Cook Islands',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'COL',
    name: 'Colombia',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'COM',
    name: 'Comoros',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CPV',
    name: 'Cabo Verde',
    preferred: false,
    primaryCurrency: 'CVE',
  },
  {
    code: 'CRI',
    name: 'Costa Rica',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CUB',
    name: 'Cuba',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CUW',
    name: 'Curaçao',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CXR',
    name: 'Christmas Island',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CYM',
    name: 'Cayman Islands',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'CYP',
    name: 'Cyprus',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'CZE',
    name: 'Czech Republic',
    preferred: false,
    primaryCurrency: 'CZK',
  },
  {
    code: 'DEU',
    name: 'Germany',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'DJI',
    name: 'Djibouti',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'DMA',
    name: 'Dominica',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'DNK',
    name: 'Denmark',
    preferred: false,
    primaryCurrency: 'DKK',
  },
  {
    code: 'DOM',
    name: 'Dominican Republic',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'DZA',
    name: 'Algeria',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'ECU',
    name: 'Ecuador',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'EGY',
    name: 'Egypt',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'ERI',
    name: 'Eritrea',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'ESH',
    name: 'Western Sahara',
    preferred: false,
    primaryCurrency: 'USD',
  },
  {
    code: 'ESP',
    name: 'Spain',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'SVK',
    name: 'Slovakia',
    preferred: false,
    primaryCurrency: 'EUR',
  },
  {
    code: 'POL',
    name: 'Poland',
    preferred: false,
    primaryCurrency: 'PLN',
  },
];
